const LANGUAGES = OPERATIONAL_LANGUAGES;

function toPosixLocale(locale) {
    return String(locale || '')
        .trim()
        .replaceAll('-', '_');
}

export function findOperationalLanguage(langToFind) {
    if (!langToFind) {
        return LANGUAGES[0];
    }

    for (const lang of LANGUAGES) {
        if (lang.aliases && lang.aliases.includes(langToFind)) {
            return lang;
        }
    }

    const normalized = langToFind.replace('_', '-').replace(' ', '').toLowerCase();

    for (const lang of LANGUAGES) {
        if (lang.dictionary.toLowerCase() === normalized) {
            return lang;
        }
        if (lang.contentLocale.toLowerCase() === normalized) {
            return lang;
        }
        if (lang.aliases && lang.aliases.includes(normalized)) {
            return lang;
        }
    }

    // If the requested language is 2-letter, try to find a language with the same prefix.
    if (normalized.length === 2) {
        for (const lang of LANGUAGES) {
            if (lang.dictionary.split('-')[0].toLowerCase() === normalized) {
                return lang;
            }
            if (lang.contentLocale.split('-')[0].toLowerCase() === normalized) {
                return lang;
            }
        }
    }

    // Didn't find a match, return the first available language.
    return LANGUAGES[0];
}

export function resolveContentLocale(requestedLocale) {
    const language = findOperationalLanguage(requestedLocale);
    const contentLocale = language?.contentLocale || LANGUAGES[0]?.contentLocale;

    return toPosixLocale(contentLocale);
}
